'use client'

type ProfileCompletionProps = {
  userId: string
  profileCompleted: boolean
}

export function ProfileCompletion({ userId: _userId, profileCompleted }: ProfileCompletionProps) {
  const completed = profileCompleted ? 8 : 2
  const total = 8
  const percentage = Math.round((completed / total) * 100)
  const completion = { completed, total, percentage }
  void _userId

  return (
    <div className="bg-background-muted border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-foreground-default">Profile Completion</h3>
        <span className="text-sm text-foreground-muted">{completion.percentage}%</span>
      </div>
      <div className="w-full bg-border rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300"
          style={{ width: `${completion.percentage}%` }}
        />
      </div>
      <p className="text-xs text-foreground-muted mt-1">
        Complete your profile to unlock all features
      </p>
    </div>
  )
}